module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "title37"
    }
  }, [_c('h1', {
    staticClass: "title-toc"
  }, [_vm._v("Table of Contents")])]), _c('div', {
    staticClass: "toc_entry"
  }, [_c('a', {
    attrs: {
      "id": "title37"
    }
  }, [_c('br')]), _c('span', {
    staticClass: "toc_entry_frontMatter",
    attrs: {
      "href": "#/e9781783408269_fm01",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "i"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("FOUL DEEDS AND SUSPICIOUS DEATHS")])]), _vm._v(" Series")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_titlePage",
    attrs: {
      "href": "#/e9781783408269_tp01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_pubInfo",
    attrs: {
      "href": "#/e9781783408269_cop01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Page")]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_dedicationPage",
    attrs: {
      "href": "#/e9781783408269_ded01"
    }
  }, [_vm._v("Dedication")]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_acknowPage",
    attrs: {
      "href": "#/e9781783408269_ack01"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Acknowledgements")])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_frontMatter",
    attrs: {
      "href": "#/e9781783408269_fm02"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Introduction")])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783408269_c01"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER 1")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("A Brief History of the Guernsey Bailiwick")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783408269_c02",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER 2")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("A Foul and Dastardly Murder and Execution")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783408269_c03",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER 3")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("The Sunny Bank Tragedy")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783408269_c04",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER 4")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("A French Tragedy")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783408269_c05",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER 5")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Watch the Wall My Darling")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783408269_c06",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER 6")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("A Pointless Death")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783408269_c07",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER 7")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Call of the Werewolf")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783408269_c08",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER 8")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("The Locket")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783408269_c09",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER 9")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("The Pirates of Jethou and Brecqhou")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783408269_c10",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER 10")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Daylight Robbery")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783408269_c11",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER 11")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("A Sarkese Murder")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783408269_c12",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER 12")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("A Crying Evil")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783408269_c13",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER 13")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Bewitching Guernsey")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783408269_c14",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER 14")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("The Grave on Herm Sands")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783408269_c15",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER 15")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("A Dastardly Tragedy")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783408269_c16",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER 16")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Escape from Death")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783408269_c17",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER 17")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Le Trepied")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783408269_c18",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER 18")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("The Magic of Brown & Polson")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783408269_c19",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER 19")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("A Christmas Murder")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783408269_c20",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER 20")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("A Brecqhou Wrecking")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783408269_c21",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER 21")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("How Did She Die?")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783408269_c22",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER 22")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Ghost of the Murdered")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783408269_c23",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER 23")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("The Bailiff’s Cross")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783408269_c24",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER 24")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Suffer the Little Children")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783408269_c25",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER 25")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("The Island of Death")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783408269_c26",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER 26")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Scandal, Intrigue and Poltroonery!")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783408269_c27",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER 27")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Murders and Mysteries of Lihou")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781783408269_c28",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CHAPTER 28")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Pictures on a Gravestone")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_biblio",
    attrs: {
      "href": "#/e9781783408269_bib01",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Bibliography")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_index",
    attrs: {
      "href": "#/e9781783408269_ind01",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Index")])]), _c('br')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65769daa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781783408269_toc01.vue
// module id = 66
// module chunks = 0